import { FC } from 'react';

export interface SearchableOption {
  value: string;
  label: string;
  description?: string;
}

interface SearchableDropdownProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  options: SearchableOption[];
  selectedValue?: string;
  onSelect: (value: string) => void;
  loading?: boolean;
  emptyMessage?: string;
  placeholder?: string;
  className?: string;
}

const SearchableDropdown: FC<SearchableDropdownProps> = ({
  searchValue,
  onSearchChange,
  options,
  selectedValue,
  onSelect,
  loading = false,
  emptyMessage = 'No results found.',
  placeholder = 'Search…',
  className,
}) => {
  return (
    <div className={className ?? ''}>
      <input
        type="search"
        value={searchValue}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={placeholder}
        className="w-full rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm text-slate-600 shadow-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/25"
      />

      {searchValue.trim().length > 0 && (
        <div className="mt-3 max-h-52 overflow-y-auto rounded-xl  bg-white shadow-inner">
          {loading ? (
            <div className="px-1 text-sm text-slate-500">Searching…</div>
          ) : options.length === 0 ? (
            <div className="px-1 text-sm text-slate-500">{emptyMessage}</div>
          ) : (
            <ul className="divide-y divide-slate-100">
              {options.map((option) => {
                const isSelected = option.value === selectedValue;

                return (
                  <li key={option.value}>
                    <button
                      type="button"
                      className={`flex w-full flex-col items-start gap-0.5 px-4 py-3 text-left text-sm transition ${isSelected
                          ? 'bg-primary/10 text-primary'
                          : 'text-slate-600 hover:bg-primary/5 hover:text-primary'
                        }`}
                      onClick={() => onSelect(option.value)}
                    >
                      <span className="font-medium">{option.label}</span>
                      {option.description ? (
                        <span className="text-xs text-slate-500">{option.description}</span>
                      ) : null}
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
